import styles from "./article-title.module.scss";

export default function ArticleTitle({
  title,
}: {
  title: string;
}): JSX.Element {
  return (
    <div className={styles.title}>
      <h1>{title}</h1>
    </div>
  );
}
